module.exports = __webpack_public_path__ + "img/cross_themeAccent.df5a9bdb.svg";